const host = process.env.VUE_APP_OSS_URL
const BASE_URL = `${host}/audio/creature/`

const TP = {
  ATTACK: 12,
  SHOOT: 15,
  MOVE: 0,
  WINCE: 3,
  DEFEND: 4,
  KILLED: 5,
  START_MOVE: 20,
  END_MOVE: 21,
}

function getSoundEffectUrl(creatureName, type) {
  return BASE_URL + `${creatureName}_${type}.mp3`
}

export {
  TP,
  getSoundEffectUrl
}
